<svelte:options customElement={{
  tag: 'list-block',
  shadow: 'none',
  props: {
    variant: { reflect: true, type: 'String' },
    items: { reflect: true, type: 'String' }
  }
}} />

<script>
  import SvgIcon from './SvgIcon.svelte';

  /**
   * list / text4：リスト・注釈
   * パーツライブラリ準拠のリスト構造
   * @prop {string} variant - リスト種別:
   *   'disc' (ul-disc), 'decimal' (ul-decimal), 'latin' (ul-latin),
   *   'upperLatin' (ul-upperLatin), 'paren' (ul-paren),
   *   'gold' (ul-gold),
   *   'star' (ul-star), 'star_num' (ul-star_num),
   *   'star_en' (ul-star_en), 'star_en_num' (ul-star_en_num),
   *   'link' (ul-link), 'link_openwin' (ul-link + openwinアイコン),
   *   'link_pdf' (ul-link + PDFアイコン)
   * @prop {string} items - JSON形式のアイテム一覧
   *   通常: '["項目1","項目2"]'
   *   link系: '[{"href":"/page","label":"リンクテキスト"}]'
   */
  export let variant = 'disc';
  export let items = '[]';

  let parsedItems = [];

  $: {
    try {
      parsedItems = typeof items === 'string' ? JSON.parse(items) : (Array.isArray(items) ? items : []);
    } catch (e) {
      console.warn('ListBlock: Invalid items JSON', e);
      parsedItems = [];
    }
  }

  const classMap = {
    disc: 'ul-disc',
    decimal: 'ul-decimal',
    latin: 'ul-latin',
    upperLatin: 'ul-upperLatin',
    paren: 'ul-paren',
    gold: 'ul-gold',
    star: 'ul-star',
    star_num: 'ul-star_num',
    star_en: 'ul-star_en',
    star_en_num: 'ul-star_en_num',
    link: 'ul-link',
    link_openwin: 'ul-link',
    link_pdf: 'ul-link'
  };

  $: listClass = classMap[variant] || 'ul-disc';
  $: isOrdered = variant === 'decimal';
  $: isLink = variant === 'link' || variant === 'link_openwin' || variant === 'link_pdf';
  $: linkIcon = variant === 'link_openwin' ? 'openwin' : variant === 'link_pdf' ? 'pdf' : '';
</script>

{#if isLink && parsedItems.length > 0}
  <ul class={listClass}>
    {#each parsedItems as item}
      <li>
        <a href={item.href || '#'} class="mod-link01" target={item.target || '_self'}>
          <span class="">{item.label || item}</span>
          {#if linkIcon}
            <SvgIcon name={linkIcon} size="sm" />
          {/if}
        </a>
      </li>
    {/each}
  </ul>
{:else if parsedItems.length > 0}
  {#if isOrdered}
    <ol class={listClass}>
      {#each parsedItems as item}
        <li>{@html item}</li>
      {/each}
    </ol>
  {:else}
    <ul class={listClass}>
      {#each parsedItems as item}
        <li>{@html item}</li>
      {/each}
    </ul>
  {/if}
{:else}
  <ul class={listClass}>
    <slot></slot>
  </ul>
{/if}
